angular.module('commerce', [
    'portal.countries',
    'portal.i18n',
    'studies',
    'ui.router',
    'user',
]);
